<template>
  <BaseTableColumn header="ID">
    <template #default="{ rowData }">
      <router-link
        :to="{ name: 'Products/Device', params: { deviceId: rowData.id } }"
        class="link"
      >
        {{ rowData.id }}
      </router-link>
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    v-if="hasSupplier"
    field="supplier.name"
    label="Supplier"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TableBoxSvg /> Supplier
      </TableHeaderWithIcon>
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    v-if="hasType"
    label="Type"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TableSegmentSvg /> Type
      </TableHeaderWithIcon>
    </template>

    <template #default="{ rowData }">
      <BaseLabel :color="getDeviceTypeLabelColor(rowData.type)">
        {{ rowData.type }}
      </BaseLabel>
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    field="part_number"
    label="Part Number"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TableJigsawSvg /> Part Number
      </TableHeaderWithIcon>
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    field="aftermarket_price"
    label="Price"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TablePriceSvg /> Price
      </TableHeaderWithIcon>
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    field="parts_per_car"
    label="Parts Per Car"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TablePartsSvg /> Parts Per Car
      </TableHeaderWithIcon>
    </template>
  </BaseTableColumn>

  <BaseTableColumn
    field="complexity"
    label="Complexity"
    is-toggable
  >
    <template #header>
      <TableHeaderWithIcon>
        <TableComplexitySvg /> Complexity
      </TableHeaderWithIcon>
    </template>
  </BaseTableColumn>

  <BaseTableActionsColumn #="{ rowData }">
    <router-link
      #="{ navigate }"
      :to="{ name: 'Products/Device', params: { deviceId: rowData.id } }"
      custom
    >
      <BaseDropdownActionsList>
        <BaseDropdownAction @click="navigate">
          Device details
        </BaseDropdownAction>
      </BaseDropdownActionsList>
    </router-link>
  </BaseTableActionsColumn>
</template>

<script>
import { TableActionsColumn as BaseTableActionsColumn, TableColumn as BaseTableColumn } from '@/components/base/Table';
import {
  DropdownAction as BaseDropdownAction,
  DropdownActionsList as BaseDropdownActionsList,
} from '@/components/base/Dropdown';
import BaseLabel from '@/components/base/Label';
import TableHeaderWithIcon from '@/components/TableHeaderWithIcon';
import TableBoxSvg from '@/assets/images/icons/table-box.svg?inline';
import TableJigsawSvg from '@/assets/images/icons/table-jigsaw.svg?inline';
import TableSegmentSvg from '@/assets/images/icons/table-segment.svg?inline';
import TablePriceSvg from '@/assets/images/icons/table-price.svg?inline';
import TablePartsSvg from '@/assets/images/icons/table-parts.svg?inline';
import TableComplexitySvg from '@/assets/images/icons/table-complexity.svg?inline';

export default {
  components: {
    BaseTableColumn,
    BaseTableActionsColumn,
    BaseDropdownAction,
    BaseDropdownActionsList,
    BaseLabel,
    TableHeaderWithIcon,
    TableBoxSvg,
    TableJigsawSvg,
    TableSegmentSvg,
    TablePriceSvg,
    TablePartsSvg,
    TableComplexitySvg,
  },
  props: {
    hasSupplier: {
      type: Boolean,
      default: false,
    },
    hasType: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getDeviceTypeLabelColor(type) {
      switch (type) {
        case 'HL':
          return 'barley';
        case 'RL':
          return 'cherry';
        case 'AuxHL':
          return 'lime';
        case 'AuxRL':
          return 'aqua';
        case 'CHMSL':
          return 'orange';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss" module>

</style>
